import { color, Common } from '@stockbit/ui';
import { FooterMobile, Separator, ButtonText } from '../styled';

const { Flex, Text, Iconmoon, IconWrapper } = Common;

interface MobileProps {
  likes: number;
  liked: string | number;
  created: string;
  showInsight: boolean;
  onClickInsight: () => void;
  onClickLike: () => void;
  onClickLikers: () => void;
  onClickShare: () => void;
  onClickComment: (val: any) => void;
}

function Mobile({
  likes,
  liked,
  created,
  showInsight,
  onClickInsight,
  onClickLike,
  onClickLikers,
  onClickShare,
  onClickComment,
}: MobileProps) {
  return (
    <FooterMobile justify="space-between" align="center">
      <Flex align="center">
        <div>
          <Flex align="center">
            <Text size="12px" color={color.midgray}>
              {created}
            </Text>
            <Separator>·</Separator>
            <ButtonText onClick={onClickLike}>
              {liked ? 'Unlike' : 'Like'}
            </ButtonText>
          </Flex>
        </div>
        <Separator>·</Separator>
        <Flex align="center">
          <ButtonText onClick={onClickShare}>
            Share
          </ButtonText>
        </Flex>
        {likes > 0 && (
          <Flex>
            <IconWrapper padding="0 0 0 5px">
              <Iconmoon
                className="icon-stream-likecircle"
                size="12px"
                color={color.primary}
              />
            </IconWrapper>
            <Text
              size="12px"
              color={color.midgray}
              ml="2px"
              onClick={onClickLikers}
            >
              {likes}
            </Text>
          </Flex>
        )}
        {showInsight && (
          <IconWrapper padding="0 20px 0 0" onClick={onClickInsight}>
            <Iconmoon
              className="icon-new_analytics"
              size="16px"
              color={color.dimgray}
            />
          </IconWrapper>
        )}
      </Flex>
      <ButtonText onClick={onClickComment}>Reply</ButtonText>
    </FooterMobile>
  );
}

export default Mobile;
